import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// The admin console mounts at the ROOT ("/") on the admin host
// (linx.swiprent.com) and under "/admin" everywhere else. Route definitions
// and in-app nav links must agree with the mount point, so every admin link is
// built from this single base instead of a hardcoded "/admin" prefix. Keeping
// the host check here (not just in App.jsx) means AdminLayout and the admin
// pages resolve the same base without importing App.
const ADMIN_HOST = "linx.swiprent.com";

export function isAdminHost() {
  try {
    return typeof window !== "undefined" && window.location.hostname === ADMIN_HOST;
  } catch {
    return false;
  }
}

// Base path the admin console is mounted at. "" on the admin host (root mount),
// "/admin" elsewhere.
export function adminBase() {
  return isAdminHost() ? "" : "/admin";
}

// Build an in-app admin link. adminLink() -> the console root, adminLink("users")
// -> "/admin/users" or "/users" depending on the host.
export function adminLink(sub = "") {
  const base = adminBase();
  const path = sub ? `/${String(sub).replace(/^\/+/, "")}` : "";
  return `${base}${path}` || "/";
}
